import { render, staticRenderFns } from "./ResendWelcome.vue?vue&type=template&id=26eb0801&"
import script from "./ResendWelcome.vue?vue&type=script&lang=ts&"
export * from "./ResendWelcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports